import { useFeature } from '@pcln/feature-components'

import useSeti from '@/hooks/useSeti'

export const VACATION_VIBE_ENTRY_EXPERIMENT = 'PKG_SEARCH_FORM_VACATION_VIBE_GENAI_ENTRY'

type UseVacationVibeEntryParams = {
  /** The packages form records exposure. Sibling footers pass false so they only read the variant. */
  shouldFireImpression?: boolean
}

export function useVacationVibeEntry({ shouldFireImpression = true }: UseVacationVibeEntryParams = {}) {
  const variant = useSeti({
    experimentCode: VACATION_VIBE_ENTRY_EXPERIMENT,
    shouldFireImpression,
  })
  // Default on: a missing packages store must not hide the banner the experiment already shows.
  const bannerEnabled = useFeature('pkgSearch.vacationVibeBannerEnabled', true) === true

  return variant === 'VARIANT' && bannerEnabled
}
